import * as React from "react";
import NotFound from "./notfound";

const Home = () => {
    return <NotFound />;
};

export default Home;
